// toggle widget
$(document).ready(function() {
	var formToggler = $("#contentWrapper .contentSection").find(".formToggler a span");

	$('.formToggler').bind('click', function(ev) {
		 var myContent = $(this).parent().next(".formContent");
		 if(myContent.is(':visible')) {
			  		$(this).find("a span").css( "background-position" , "-36px -30px" );
			  } else {
				  	$(this).find("a span").css( "background-position" , "-4px -30px" );
			  };
		  myContent.stop(true, true).slideToggle('slow');
	});
});
